<template>
	<div class="font-select">
		<div class="dropdown-button">{{selected.name || 'Выберите шрифт'}}</div>
		<div class="dropdown">
			<div class="font-holder" 
				 v-for="font in fonts" 
				 @click="selectFont(font)"
				 :style="font.style">
				 {{font.label}}
			</div>
		</div>
	</div>
</template>

<script>
import Fonts from "../../assets/json/fonts.json";
export default {
	props:{
		value: Number
	},
  name: 'font-select',
  methods:{
  	openDropDown(){
  		//console.log(this)
  	},
  	selectFont(font){
  		this.selected = _.find(Fonts, {id: font.id});
  		this.$emit('input', font.id);
  	}
  },
	computed:{
		fonts(){
			return Fonts.map((font)=>{
				return {id:font.id,label:font.name, value:font.id, style: `font-family: '${font.name}', ${font.family};`}
			});
		}
	},
  data () {
    return {
    	selected: false
    }
  }
}
</script>

<style lang="css" scoped>
.dropdown-button{
	font-size:12px;
	border-bottom: 1px solid lightgrey;
	padding:2px 0;
}
.dropdown{
	text-align: left;
	height:200px;
	overflow: hidden;
	overflow-y:scroll;
}
.font-holder{
	padding:2px 4px;
	cursor: pointer;

}
.font-holder:hover{
	background: whitesmoke;
}
.font-select{
	border:1px solid lightgrey;
	padding:2px;
	margin:4px 0 0 0;
}
</style>